import { Modal } from 'antd';
import { ReactElement, useMemo } from 'react';
import Image from '@/components/LocalImage';
import styles from '@/styles/components/shade-loding.module.less';
import SwapLoad from './SwapLoad';
import SignLoad from './SignLoad';
import MintLoad from './MintLoad';
import BurnLoad from './BurnLoad';
import TicketLoad from './TicketLoad';
import TokenMintLoad from './TokenMintLoad';
import AddLiquidityLoad from './AddLiquidityLoad';
import RemoveLiquidityLoad from './RemoveLiquidityLoad';
import X402LocalLoad from './X402LocalLoad';
import CustomModal from '../CustomModal';
const ShadeLoading = (props: ShadeLoadingProps): ReactElement => {
    const loadContent = useMemo(() => {
        switch (props.type) {
            case 'sign':
                return <SignLoad />;
            case 'mint':
                return <MintLoad {...(props.swapLoadData as SwapLoadData)} />;
            case 'burn':
                return <BurnLoad {...(props.swapLoadData as SwapLoadData)} />;
            case 'loading':
                return <p>{props.swapLoadData as string}</p>;
            case 'token.mint':
                return <TokenMintLoad {...(props.swapLoadData as SwapLoadData)} />;
            case 'token.create':
                return <p>{props.swapLoadData as string}</p>;
            case 'msg':
                return <p>{props.swapLoadData as string}</p>;
            case 'liquidity':
                return <AddLiquidityLoad {...(props.swapLoadData as AddLiquidityData)}></AddLiquidityLoad>;
            case 'liquidity.remove':
                return <RemoveLiquidityLoad {...(props.swapLoadData as AddLiquidityData)}></RemoveLiquidityLoad>;
            case 'Ticket':
                return <TicketLoad {...(props.swapLoadData as SwapLoadData)} />;
            case 'x402.local':
                return <X402LocalLoad {...(props.swapLoadData as X402PaymentRequirement)} />;
            case 'swap':
                if (!props.swapLoadData) {
                    return <SwapLoad token="0" tokenSymbol="" cToken="0" cTokenSymbol="" tokenIcon="" cTokenIcon="" />;
                } else {
                    return <SwapLoad {...(props.swapLoadData as SwapLoadData)} />;
                }
            default:
                return <span />;
        }
    }, [props.type, props.swapLoadData]);

    return (
        <CustomModal closable={false} centered open={props.visible} width={500} styles={{ body: bodyStyle }} footer={null}>
            <div className={styles['loding-style']}>
                {props.showLoading ? (
                    <div className={styles['img-div']}>
                        <Image className={styles['loading-img']} name="loading" width={100} height={100} type="png" dir="/images/components"></Image>
                    </div>
                ) : (
                    <></>
                )}
                {props.visible ? loadContent : <></>}
            </div>
        </CustomModal>
    );
};

const bodyStyle: React.CSSProperties = {
    color: '#FFF',
    height: '400px',
    backgroundColor: '#000000',
};


export default ShadeLoading;
